import React from 'react';
import { Phone, ArrowRight } from 'lucide-react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { companyInfo } from '../../data/mock';

export const ContactCTA = () => {
  return (
    <Section background="blue" className="relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-white blur-3xl" />
        <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-secondary blur-3xl" />
      </div>

      <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-12">
        <div className="text-center lg:text-left max-w-2xl">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Spremni za Novi Izgled Vašeg Doma?
          </h2>
          <p className="text-blue-100 text-lg mb-8 leading-relaxed">
            Kontaktirajte nas za besplatnu procenu i savetovanje. 
            Naš tim je spreman da odgovori na sve vaše zahteve i pruži najbolje rešenje.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
            <a href={`tel:${companyInfo.phone}`}>
              <Button variant="white" size="lg" className="w-full sm:w-auto gap-2">
                <Phone size={20} /> Pozovite Nas
              </Button>
            </a>
            <a href="/kontakt">
              <Button variant="outline" size="lg" className="w-full sm:w-auto border-white text-white hover:bg-white/10 gap-2">
                Zatraži Ponudu <ArrowRight size={20} />
              </Button>
            </a>
          </div>
        </div>

        {/* Visual Element */}
        <div className="hidden lg:block relative">
          <div className="w-64 h-64 border-4 border-white/20 rounded-full flex items-center justify-center animate-spin-slow">
            <div className="w-48 h-48 border-4 border-white/40 rounded-full flex items-center justify-center">
              <div className="w-32 h-32 bg-white text-primary rounded-full flex items-center justify-center font-bold text-xl shadow-xl">
                10+ Godina
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};
